export const STABLE_QZ_QUERY_SETTINGS = Object.freeze({
  cacheTime: Infinity,
  refetchOnWindowFocus: false,
  staleTime: Infinity,
});
